import {Component, input, model, OnInit, output} from '@angular/core';
import {NgClass} from '@angular/common';

@Component({
  selector: 'dm-input-switch',
  imports: [
    NgClass
  ],
  templateUrl: './input-switch.html',
  styleUrl: './input-switch.scss',
})
export class InputSwitch implements OnInit {
  active = model<boolean>(true);
  scale = model<number>();
  autoToggle = input<boolean>();
  disabled = input<boolean>();
  initAsFalse = input<boolean>();

  switch = output<boolean>();
  switchOn = output<void>();
  switchOff = output<void>();

  ngOnInit() {
    if (this.initAsFalse()) {
      this.switch.emit(false);
      this.switchOff.emit();
    }

    if (!this.scale()) this.scale.set(1);
  }

  toggle(): void {
    if (this.disabled()) return;

    if (this.autoToggle()) {
      this.active.set(!this.active());
      this.switch.emit(this.active());
      this.switchOnOrOff(this.active());
    } else {
      this.switch.emit(!this.active());
      this.switchOnOrOff(!this.active());
    }
  }

  switchOnOrOff(value: boolean): void {
    value ? this.switchOn.emit() : this.switchOff.emit();
  }
}
